import React from "react";

export const PaymentRowLayout = (props) => {
  return (
    <div className="row justify-content-between mb-1">
      <div className="col-8 row">
        <div className="col-md-6">
          <label className="form-control-label">{props.first}</label>
        </div>
        <div className="col-md-6">
          <label className="form-control-label">{props.second}</label>
        </div>
      </div>
      <div className="col-4 d-flex align-items-center justify-content-end">
        <label className="form-control-label">{props.third}</label>
      </div>
    </div>
  );
};